export const makeBold = {
    fontWeight:600
}